// @ts-nocheck
import _ from 'lodash';
import PropTypes from 'prop-types';
import { makeStyles, Box, Grid, Typography } from '@material-ui/core';
import { StringUtils } from '../../../../common/utils';
import MultiVoucherSection from './MultiVoucherSection';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    overflow: 'auto',
  },
  content: {
    maxHeight: '468px',
    paddingRight: theme.spacing(3),
    '& .MuiTypography-body1': {
      wordBreak: 'break-word',
    },
  },
  label: {
    padding: theme.spacing(1, 0),
    fontWeight: 'bold',
  },
  value: {
    padding: theme.spacing(1, 0),
  },
  separator: {
    marginBottom: '3px',
    borderBottom: `1px dashed ${theme.palette.divider}`,
  },
}));

function MultiVoucherDetailsSection(props) {
  const classes = useStyles();

  const { id, title, className, data, emptyContent, seriesId, onDownloadVouchers } = props;

  return (
    <MultiVoucherSection
      id={id}
      className={className}
      title={title}
      onDownloadVouchers={onDownloadVouchers}
      seriesId={seriesId}
    >
      <Box className={classes.container}>
        {!_.isEmpty(data) ? (
          <Box className={classes.content}>
            {data.map(item => (
              <Grid
                id={StringUtils.makeId(id, item.id)}
                key={item.id}
                container
                item
                xs={12}
                className={classes.separator}
              >
                <Grid item xs={5}>
                  <Typography
                    id={StringUtils.makeId(id, `${item.id}Label`)}
                    className={classes.label}
                  >
                    {`${item.label}:`}
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  {!_.isNil(item.value) && (
                    <Typography
                      id={StringUtils.makeId(id, `${item.id}Value`)}
                      className={classes.value}
                    >
                      {item.formatter ? item.formatter(item.value) : item.value}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            ))}
          </Box>
        ) : (
          <>{emptyContent}</>
        )}
      </Box>
    </MultiVoucherSection>
  );
}

MultiVoucherDetailsSection.defaultProps = {
  id: undefined,
  className: undefined,
  emptyContent: undefined,
  seriesId: undefined,
  actiosDisabled: undefined,
  onDownloadVouchers: undefined,
};

MultiVoucherDetailsSection.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.any]),
      formatter: PropTypes.func,
    })
  ).isRequired,
  emptyContent: PropTypes.node,
  seriesId: PropTypes.number.isRequired,
  actiosDisabled: PropTypes.func.isRequired,
  onDownloadVouchers: PropTypes.func.isRequired,
};

export default MultiVoucherDetailsSection;
